class TravelInsurancePriceRequest {
  covidincluded = false;
  companyid = null;
  currency = null;
}

export default TravelInsurancePriceRequest;
